export const EventLinearChartSectionSkeleton = ({ title }: { title: string }) => {
  return (
    <section className='mb-20 md:mb-32 overflow-hidden'>
      <h2 className='text-headline-s md:text-headline-m px-4 mb-6 text-tertiary'>{title}</h2>

      <div className='px-4 pb-8 md:pb-10 flex gap-2 animate-pulse'>
        {Array.from({ length: 3 }, (_, i) => (
          <div key={`chart-tab-${i}`} className='bg-tertiary h-9 w-20 rounded-full'></div>
        ))}
      </div>

      <div className='flex justify-between mb-8 md:mb-10 animate-pulse'>
        <div className='px-4'>
          <div className='h-10 w-32 bg-tertiary rounded-sm'></div>
        </div>
        <div className='px-4 flex gap-1'>
          {Array.from({ length: 3 }, (_, i) => (
            <div key={`chart-range-${i}`} className='h-8 w-16 bg-tertiary rounded-sm'></div>
          ))}
        </div>
      </div>

      <div className='h-80 md:h-72 bg-tertiary rounded-sm mb-8 animate-pulse'></div>

      <div className='flex gap-x-3 overflow-x-scroll scrollbar-hide pb-1 px-4 animate-pulse'>
        {Array.from({ length: 4 }, (_, i) => (
          <div key={`chart-legend-${i}`} className='bg-tertiary h-6 w-24 rounded-full'></div>
        ))}
      </div>
    </section>
  );
};
